import React from "react"
import PropTypes from "prop-types"
import { StyledGrid } from "./styles"

const Grid = ({ children, gap, grid, template, placeItems, placeContent, gridArea, mobile, ...rest }) => (
  <StyledGrid
    gap={gap}
    grid={grid}
    template={template}
    placeItems={placeItems}
    placeContent={placeContent}
    gridArea={gridArea}
    mobile={mobile}
    {...rest}
  >
    {children}
  </StyledGrid>
)

Grid.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.string,
  grid: PropTypes.string,
  template: PropTypes.string,
  placeItems: PropTypes.string,
  placeContent: PropTypes.string,
  gridArea: PropTypes.string,
  mobile: PropTypes.bool
}

Grid.defaultProps = {
  children: null,
  gap: "2rem",
  grid: "none",
  template: "none",
  placeItems: undefined,
  placeContent: undefined,
  gridArea: undefined,
  mobile: false
}

export default Grid
